"use client";
import React from "react";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const Team = ({ title, people }) => {
  return (
    <div className="aboutModule mPadding pb-5 mx-auto">
      <h3>Our Team</h3>
      <div className="cWrapper mPadding">
        <ul>
          {people.map((person, index) => {
            return (
              <li key={index}>
                {person.photo?.data?.attributes?.url ? (
                  <Image
                    src={getImageURL(person.photo.data.attributes.url)}
                    alt=""
                    width={person.photo.data.attributes.width || 200}
                    height={person.photo.data.attributes.height || 200}
                  />
                ) : (
                  <div className="photoPlaceholder"></div>
                )}
                <h4>{person.name}</h4>
                <div>{person.title}</div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Team;
